if (!customElements.get('range-slider')) {
  customElements.define(
    'range-slider',
    class RangeSlider extends HTMLElement {
      constructor() {
        super();

        this.minSlider = document.getElementById('Mobile-Filter-Price-GTE');
        this.maxSlider = document.getElementById('Mobile-Filter-Price-LTE');
        this.minValueBox = document.getElementById('min-value');
        this.maxValueBox = document.getElementById('max-value');
        this.maxSliderMax = parseFloat(this.maxSlider.max); // Use parseFloat for decimal values
        this.minSlider.addEventListener('input', this.handleMinSlider.bind(this));
        this.maxSlider.addEventListener('input', this.handleMaxSlider.bind(this));

        // Add event listeners for input fields
        this.minValueBox.addEventListener('input', this.handleMinValueInput.bind(this));
        this.maxValueBox.addEventListener('input', this.handleMaxValueInput.bind(this));

        this.minSlider.dispatchEvent(new Event('input'));
        this.maxSlider.dispatchEvent(new Event('input'));
      }

      handleMinSlider() {
        const minValue = parseFloat(this.minSlider.value);
        const maxValue = parseFloat(this.maxSlider.value);

        if (minValue > maxValue - 10) {
          this.minSlider.value = (maxValue - 10).toFixed(2); // Ensure two decimal places
        }

        this.minValueBox.value = this.minSlider.value; // Update input field
        this.updateBackground();
      }

      handleMaxSlider() {
        const minValue = parseFloat(this.minSlider.value);
        const maxValue = parseFloat(this.maxSlider.value);

        if (maxValue < minValue + 10) {
          this.maxSlider.value = (minValue + 10).toFixed(2); // Ensure two decimal places
        }

        this.maxValueBox.value = this.maxSlider.value; // Update input field
        this.updateBackground();
      }

      handleMinValueInput() {
        const value = this.minValueBox.value;
        if (/^\d*\.?\d*$/.test(value)) {
          // Regex to allow numbers and decimals
          this.minSlider.value = parseFloat(value);
          this.updateBackground();
        } else {
          this.minValueBox.value = this.minSlider.value; // Reset to last valid value
        }
      }

      handleMaxValueInput() {
        const value = this.maxValueBox.value;
        if (/^\d*\.?\d*$/.test(value)) {
          // Regex to allow numbers and decimals
          this.maxSlider.value = parseFloat(value);
          this.updateBackground();
        } else {
          this.maxValueBox.value = this.maxSlider.value; // Reset to last valid value
        }
      }

      updateBackground() {
        const minValue = parseFloat(this.minSlider.value);
        const maxValue = parseFloat(this.maxSlider.value);
        const minPercent = (minValue / this.maxSliderMax) * 100;
        const maxPercent = (maxValue / this.maxSliderMax) * 100;

        this.minSlider.style.setProperty('--min-range', `${minPercent}%`);
        this.maxSlider.style.setProperty('--min-range', `${minPercent}%`);
        this.maxSlider.style.setProperty('--max-range', `${maxPercent}%`);
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.value-box').forEach((valueBox) => {
    valueBox.addEventListener('click', () => {
      valueBox.querySelector('input').focus();
    });
  });
});
